import React from 'react';
import './Footer.css';

const Footer = ({ data }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p>&copy; {currentYear} {data.name}. All rights reserved.</p>
          <p className="footer-tagline">Building intelligent solutions with AI and modern web technologies</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
